import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivezeroseatterbus() {


const cardData = {
keyword: "50 Seater Bus On Rent in Pune",
headingDescription: "Ruturaj Enterprises provides dependable 50 Seater Bus On Rent in Pune for schools, colleges, corporate teams, wedding parties, large families, tourist groups, event organizers, and other organizations requiring high-capacity group transportation. A 50-seater bus is an excellent option when a large number of passengers need to travel together, helping simplify transportation planning for local sightseeing, airport transfers, educational excursions, weddings, corporate programs, picnics, family holidays, and long-distance tours from Pune.",
topPlaces: [
{
title: "Bhimashankar",
description: "Bhimashankar is a popular pilgrimage and nature destination surrounded by forested landscapes and scenic hills. Large groups traveling from Pune for religious visits, family outings, or nature excursions can use a 50 seater bus to keep passengers together throughout the planned journey."
},
{
title: "Matheran",
description: "Matheran is a peaceful hill destination known for viewpoints, greenery, and its vehicle-free atmosphere in the main tourist area. A 50 seater bus is suitable for large school groups, families, corporate teams, and tourist parties traveling together from Pune."
},
{
title: "Murud",
description: "Murud offers a combination of coastal scenery, beaches, and historic attractions, making it a popular destination for group holidays. A high-capacity 50 seater bus is useful for large families, friends, corporate groups, and organized tourist parties carrying luggage for a coastal trip."
},
{
title: "Bhandardara",
description: "Bhandardara is known for its lake, mountains, waterfalls, and peaceful natural surroundings, attracting families and group travelers. A 50 seater bus provides a convenient option for larger parties planning a picnic, camping trip, corporate outing, or nature-focused holiday from Pune."
},
{
title: "Ganpatipule",
description: "Ganpatipule is a well-known Konkan destination featuring a beautiful coastline and an important temple, making it suitable for both leisure and pilgrimage trips. Large groups from Pune can travel together in a 50 seater bus while carrying luggage and coordinating their multi-day itinerary."
},
{
title: "Panhala",
description: "Panhala is a historic hill destination known for its fort, scenic surroundings, and connection with Maharashtra's heritage. A 50 seater bus can support school excursions, family tours, history-focused trips, and large tourist groups traveling from Pune."
},
{
title: "Tadoba",
description: "Tadoba is a prominent wildlife destination that attracts nature enthusiasts, families, photographers, and organized travel groups. A 50 seater bus can provide shared transportation for larger groups traveling from Pune for a planned wildlife and nature experience."
},
{
title: "Kolad",
description: "Kolad is known for its river activities, greenery, adventure experiences, and weekend tourism, making it popular with group travelers. Large corporate teams, friends, families, and adventure groups can use a 50 seater bus for organized transportation from Pune."
},
{
title: "Chiplun",
description: "Chiplun is surrounded by the scenic Western Ghats and offers access to rivers, temples, waterfalls, and Konkan landscapes. A 50 seater bus is practical for large families, tourist groups, corporate outings, and organized travel parties planning a longer journey from Pune."
},
{
title: "Tuljapur",
description: "Tuljapur is an important pilgrimage destination visited by devotees and organized religious groups from across Maharashtra. A 50 seater bus allows a larger pilgrimage party to travel together while coordinating temple visits, luggage, scheduled stops, and return travel more conveniently."
}
],
services: [
{
name: "50 Seater Bus Rental Pune",
description: "Ruturaj Enterprises offers 50 Seater Bus Rental Pune services for schools, colleges, large families, corporate teams, wedding groups, tourist parties, event organizers, and other organizations requiring high-capacity transportation. The bus can be arranged for local travel, sightseeing, airport transfers, picnics, celebrations, family tours, educational trips, and long-distance journeys."
},
{
name: "50 Seater Bus Hire Pune",
description: "50 Seater Bus Hire Pune is a practical option for groups that need to transport many passengers together in one dedicated vehicle. It can be used for weddings, corporate events, school excursions, family vacations, tourist programs, social gatherings, group outings, and organized travel requirements."
},
{
name: "50 Seater Bus Booking Pune",
description: "50 Seater Bus Booking Pune can be planned for local sightseeing, weekend getaways, multi-day tours, airport transfers, wedding functions, corporate programs, school trips, and outstation journeys. Advance booking helps coordinate passenger numbers, pickup locations, destinations, schedules, luggage requirements, and other itinerary details."
},
{
name: "50 Seater AC Bus on Rent Pune",
description: "50 Seater AC Bus on Rent Pune is suitable for large groups looking for an air-conditioned transportation option for comfortable travel. It can be considered for family vacations, corporate tours, school excursions, weddings, airport transfers, tourist journeys, and longer routes from Pune."
},
{
name: "50 Seater Luxury Bus Rental Pune",
description: "50 Seater Luxury Bus Rental Pune provides a premium-oriented transportation solution for larger groups traveling for special occasions, business programs, and important journeys. It is suitable for corporate events, wedding functions, family celebrations, private tours, tourist groups, and other occasions where enhanced comfort is preferred."
},
{
name: "50 Seater Bus for Outstation Pune",
description: "50 Seater Bus for Outstation Pune is ideal for large groups traveling from Pune to destinations across Maharashtra and neighboring states. A dedicated high-capacity bus helps passengers remain together while making luggage management, planned breaks, route coordination, sightseeing stops, and return travel easier."
},
{
name: "50 Seater Bus for Wedding Pune",
description: "50 Seater Bus for Wedding Pune is useful for transporting large numbers of relatives and guests between residences, hotels, temples, marriage halls, banquet venues, and reception locations. Its high seating capacity can help wedding organizers manage guest transportation more efficiently during multiple ceremonies."
},
{
name: "50 Seater Bus for Corporate Events Pune",
description: "50 Seater Bus for Corporate Events Pune can be arranged for conferences, seminars, exhibitions, employee gatherings, training programs, team outings, and business functions. A high-capacity bus allows larger corporate teams to travel together between offices, hotels, event venues, and other scheduled destinations."
},
{
name: "50 Seater Bus for School Trips Pune",
description: "50 Seater Bus for School Trips Pune provides a useful group transportation solution for educational excursions, historical tours, museums, nature visits, recreational outings, and school picnics. The larger seating capacity is particularly suitable when many students, teachers, and accompanying staff need to travel together."
},
{
name: "50 Seater Bus for Group Travel Pune",
description: "50 Seater Bus for Group Travel Pune is suitable for large groups of friends, relatives, colleagues, tourists, community members, and organized travelers. One dedicated vehicle can simplify passenger coordination, pickup planning, route management, parking, luggage handling, and overall group movement."
},
{
name: "50 Seater Bus for Family Trip Pune",
description: "50 Seater Bus for Family Trip Pune is a convenient choice for extended families and large relatives groups traveling together for holidays, pilgrimages, weekend getaways, and destination tours. Everyone can travel together while luggage, scheduled stops, sightseeing plans, and return arrangements are managed more conveniently."
},
{
name: "50 Seater Bus for Airport Pickup Pune",
description: "50 Seater Bus for Airport Pickup Pune is useful for large families, corporate teams, wedding parties, tourist groups, and organizations requiring coordinated transportation to or from Pune Airport. A high-capacity bus can accommodate many passengers and their luggage together, reducing the need for multiple airport vehicles."
},
{
name: "50 Seater Bus Near Me Pune",
description: "50 Seater Bus Near Me Pune is useful for travelers searching for a high-capacity bus rental service within Pune. Ruturaj Enterprises supports local sightseeing, airport transfers, weddings, corporate travel, school excursions, family tours, picnics, events, tourist journeys, and outstation requirements."
},
{
name: "Affordable 50 Seater Bus Rental Pune",
description: "Affordable 50 Seater Bus Rental Pune provides a practical shared transportation solution for organizations and groups that need to move many passengers together. One dedicated bus can simplify transportation planning for family tours, school trips, corporate programs, weddings, tourist journeys, picnics, and events."
},
{
name: "50 Seater Bus for Picnic Pune",
description: "50 Seater Bus for Picnic Pune is suitable for schools, families, offices, friends, clubs, community groups, and organizations arranging large recreational outings. The high seating capacity allows participants to remain together while carrying food, bags, outdoor equipment, and other picnic essentials."
},
{
name: "50 Seater Bus for Marriage Function Pune",
description: "50 Seater Bus for Marriage Function Pune can be arranged for transporting a large number of relatives and guests during marriage ceremonies, receptions, and related celebrations. It is convenient for scheduled movement between homes, hotels, temples, banquet halls, wedding venues, and other function locations."
},
{
name: "50 Seater Bus for Corporate Travel Pune",
description: "50 Seater Bus for Corporate Travel Pune provides high-capacity transportation for employees attending meetings, business tours, conferences, training programs, client visits, and company activities. A shared bus helps larger teams travel according to a common schedule and reduces the complexity of coordinating several vehicles."
},
{
name: "50 Seater Bus for Event Pune",
description: "50 Seater Bus for Event Pune is suitable for exhibitions, conferences, cultural programs, social gatherings, corporate functions, private celebrations, and other events requiring transportation for many participants. Event organizers can use a dedicated bus to coordinate passenger movement between pickup points, hotels, venues, and event destinations."
},
{
name: "50 Seater Bus for Tourist Trip Pune",
description: "50 Seater Bus for Tourist Trip Pune offers convenient transportation for large tourist parties visiting multiple attractions and destinations. It can support sightseeing circuits, heritage tours, pilgrimage journeys, family holidays, weekend vacations, and organized tourism programs starting from Pune."
},
{
name: "50 Seater Bus for Outstation Tour Pune",
description: "50 Seater Bus for Outstation Tour Pune is suitable for large groups planning long-distance vacations, destination tours, pilgrimage journeys, weekend getaways, and multi-day itineraries. A dedicated high-capacity bus helps simplify passenger coordination, luggage handling, scheduled breaks, sightseeing stops, and return arrangements."
},
{
name: "50 Seater AC Bus Hire Pune",
description: "50 Seater AC Bus Hire Pune provides an air-conditioned transportation option for larger groups seeking a comfortable shared journey. It can be considered for airport transfers, weddings, corporate programs, school trips, family vacations, tourist tours, local sightseeing, and outstation travel."
},
{
name: "50 Seater Luxury Bus on Rent Pune",
description: "50 Seater Luxury Bus on Rent Pune is suitable for large groups looking for a premium-oriented transportation arrangement for special occasions and extended journeys. It can be used for wedding functions, corporate events, private tours, family celebrations, tourist trips, and other group travel requirements where enhanced comfort is preferred."
}
],
tableData: [
["50 Seater Bus Rental Pune", "50 Seater Bus Hire Pune"],
["50 Seater Bus Booking Pune", "50 Seater AC Bus on Rent Pune"],
["50 Seater Luxury Bus Rental Pune", "50 Seater Bus for Outstation Pune"],
["50 Seater Bus for Wedding Pune", "50 Seater Bus for Corporate Events Pune"],
["50 Seater Bus for School Trips Pune", "50 Seater Bus for Group Travel Pune"],
["50 Seater Bus for Family Trip Pune", "50 Seater Bus for Airport Pickup Pune"],
["50 Seater Bus Near Me Pune", "Affordable 50 Seater Bus Rental Pune"],
["50 Seater Bus for Picnic Pune", "50 Seater Bus for Marriage Function Pune"],
["50 Seater Bus for Corporate Travel Pune", "50 Seater Bus for Event Pune"],
["50 Seater Bus for Tourist Trip Pune", "50 Seater Bus for Outstation Tour Pune"],
["50 Seater AC Bus Hire Pune", "50 Seater Luxury Bus on Rent Pune"]
],
whychoose: [
{
WhyChooseheading: "Large Seating Capacity",
WhyChoosedescription: "A 50 seater bus is an effective transportation choice when a very large number of passengers need to travel together. It is suitable for school groups, corporate teams, wedding parties, large families, tourist groups, and organized events."
},
{
WhyChooseheading: "Simplified Group Transportation",
WhyChoosedescription: "Arranging several smaller vehicles for a large group can make communication, route coordination, parking, and arrival timings more complicated. A single high-capacity bus provides a centralized transportation arrangement and helps keep passengers on the same schedule."
},
{
WhyChooseheading: "Suitable for Long-Distance Travel",
WhyChoosedescription: "Extended journeys require practical transportation for passengers as well as their luggage and travel essentials. A 50 seater bus is suitable for family vacations, pilgrimage tours, corporate journeys, educational excursions, tourist circuits, and multi-day trips from Pune."
},
{
WhyChooseheading: "Convenient Wedding Guest Transfers",
WhyChoosedescription: "Large marriage functions may involve guests traveling between multiple accommodation and event locations. A 50 seater bus can transport a substantial group of relatives and guests while helping organizers coordinate movement between ceremonies, hotels, halls, temples, and reception venues."
},
{
WhyChooseheading: "Effective for Corporate Group Movement",
WhyChoosedescription: "Businesses organizing conferences, employee outings, training programs, exhibitions, seminars, or corporate events can benefit from high-capacity transportation. A dedicated bus allows a larger team to travel together and simplifies movement between offices, hotels, and event venues."
},
{
WhyChooseheading: "AC and Premium Travel Choices",
WhyChoosedescription: "Different journeys call for different levels of comfort depending on the route, weather, duration, and purpose of travel. AC and luxury-oriented 50 seater options provide greater flexibility for groups planning comfortable transportation for important or extended trips."
},
{
WhyChooseheading: "Useful for School Excursions and Picnics",
WhyChoosedescription: "Educational tours, school picnics, nature excursions, and recreational programs can involve a substantial number of students and accompanying staff. A 50 seater bus offers a convenient shared transportation arrangement for keeping participants together during planned outings."
},
{
WhyChooseheading: "Versatile for Local and Outstation Travel",
WhyChoosedescription: "Ruturaj Enterprises supports 50 seater bus requirements for airport transfers, local sightseeing, weddings, family vacations, corporate transportation, school trips, picnics, events, tourist programs, and longer journeys from Pune. Travel arrangements can be planned according to passenger capacity, pickup points, destination, duration, and itinerary requirements."
}
]
};









const faqData = [
{
question: "Why choose Ruturaj Enterprises for a 50 Seater Bus on rent in Pune?",
answer: "Ruturaj Enterprises provides 50 Seater Bus rental services for large groups that need organized and convenient transportation. This high-capacity bus is suitable for corporate events, school and college tours, weddings, pilgrimages, family functions, sightseeing programs, and long-distance group travel."
},
{
question: "Who can hire a 50 Seater Bus in Pune?",
answer: "Companies, schools, colleges, tour operators, wedding organizers, large families, event planners, and social groups can rent a 50 Seater Bus when transportation is required for a substantial number of passengers. One large bus can simplify group movement and scheduling."
},
{
question: "Can I rent a 50 Seater Bus from Pune for an outstation trip?",
answer: "A 50 Seater Bus can be arranged for outstation journeys from Pune to destinations such as Mumbai, Goa, Shirdi, Nashik, Mahabaleshwar, Kolhapur, Konkan, and other cities or tourist destinations. The trip can be planned according to the group's preferred route and schedule."
},
{
question: "Is a 50 Seater Bus suitable for large family tours?",
answer: "Extended families traveling together can consider a 50 Seater Bus for vacations, reunions, religious journeys, wedding-related travel, and sightseeing tours. Traveling in one vehicle can make it easier to coordinate a large group throughout the journey."
},
{
question: "Can I book a 50 Seater Bus for wedding and marriage functions?",
answer: "Wedding families can arrange a 50 Seater Bus for transporting relatives and guests between residences, hotels, marriage halls, reception venues, railway stations, and airports. The large seating capacity is useful when many guests need transportation for multiple ceremonies and events."
},
{
question: "Can corporate companies hire a 50 Seater Bus in Pune?",
answer: "Corporate organizations can use a 50 Seater Bus for employee transportation, conferences, seminars, annual functions, team outings, training programs, industrial visits, and company tours. A dedicated large-capacity vehicle can help manage employee movement according to the event schedule."
},
{
question: "Is a 50 Seater Bus suitable for school and college trips?",
answer: "Schools and colleges can rent a 50 Seater Bus for educational excursions, picnics, industrial visits, study tours, cultural programs, and recreational trips. Having students and accompanying staff travel together can make the transportation plan easier to coordinate."
},
{
question: "Can I hire a 50 Seater Bus for sightseeing from Pune?",
answer: "Large sightseeing groups can choose a 50 Seater Bus when their itinerary covers multiple attractions in Pune or nearby destinations. The spacious group capacity makes it suitable for organized tours where passengers want to remain together from the starting point through the return journey."
},
{
question: "Can a 50 Seater Bus be used for airport and railway station transfers?",
answer: "Tour groups, wedding parties, corporate teams, educational groups, and large families can use a 50 Seater Bus for Pune Airport and railway station transfers. Coordinating a large number of passengers through one vehicle can make pickup, drop-off, luggage handling, and onward travel more manageable."
},
{
question: "How can I book a 50 Seater Bus on rent in Pune?",
answer: "To plan a 50 Seater Bus rental with Ruturaj Enterprises, provide the pickup point, destination, travel date, number of passengers, journey duration, and route details. Sharing the complete itinerary helps in arranging transportation according to the group's specific travel requirements."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Vijay Chavan",
feedback:
"Our extended family rented a 50 Seater Bus from Ruturaj Enterprises for an outstation family function. With such a large group, having everyone travel together made the entire transportation plan much easier. The bus was a practical solution for our journey and helped us stay coordinated.",
rating: 5
},
{
id: 2,
name: "Miss. Sneha Kulkarni",
feedback:
"We booked a 50 Seater Bus from Ruturaj Enterprises for our college tour. Managing transportation for the complete group was much simpler with one dedicated bus, and everyone could follow the same itinerary. It made the travel arrangements convenient for our educational trip.",
rating: 5
}
];



















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/50-seater-bus-on-rent-in-pune.webp",
  "description":
    "50 Seater Bus On Rent in Pune from Ruturaj Enterprises is a practical group transportation solution for large families, corporate teams, wedding groups, schools, colleges, institutions, tour operators and organized travel groups. 50 Seater Bus Rental Pune is suitable for local sightseeing, family tours, corporate outings, wedding guest transportation, school trips, college excursions, pilgrimage tours, airport transfers and long-distance journeys. With a spacious 50-passenger capacity, groups can coordinate their travel in a single vehicle instead of arranging several smaller cars, making pickup, drop and itinerary management more convenient. 50 Seater Bus Hire Pune can be arranged according to the number of passengers, travel dates, destination, route, duration and trip schedule. 50 Seater Bus Booking Pune is suitable for advance planning of weekend trips, holiday tours, events, group functions and multi-day journeys. 50 Seater AC Bus on Rent Pune provides a comfortable option for travelling during warm weather, while 50 Seater Luxury Bus Rental Pune is suitable for premium group transportation during weddings, corporate programs, special events, tours and organized excursions. 50 Seater Bus for Outstation Pune can be used for journeys to Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran, Ratnagiri, Ganpatipule and other Maharashtra and interstate destinations. 50 Seater Bus for Wedding Pune is useful for transporting guests between hotels, wedding venues, reception locations, airports and railway stations, while 50 Seater Bus for Corporate Events Pune can support employee outings, conferences, seminars, exhibitions, training programs, business visits and large company events. 50 Seater Bus for School Trips Pune is suitable for educational tours, school picnics, excursions, industrial visits and student transportation, while 50 Seater Bus for Group Travel Pune is convenient for family vacations, friends trips, tourist groups and customized road journeys. Airport pickup and drop, railway station transfers, hotel transportation and resort transfers can also be included in customized travel plans. Pune Darshan, temple visits, pilgrimage routes, religious tours and local sightseeing programs can be planned with a dedicated vehicle and driver. Pickup and drop services can be arranged from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and nearby Pune areas. Ruturaj Enterprises supports full-day, weekend, multi-day, local and outstation 50 Seater Bus rental requirements for weddings, corporate events, school trips, family tours, group holidays, sightseeing, pilgrimages and customized large-group transportation from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/50-seater-bus-on-rent-in-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>50 Seater Bus On Rent in Pune | 50 Seater Bus Rental Pune | +91 9763381382</title>

  <meta
    name="description"
    content="50 Seater Bus On Rent in Pune for large group travel, weddings, corporate events, school trips, family tours, sightseeing, airport transfers and outstation journeys with driver."
  />

  <meta
    name="keywords"
    content="50 Seater Bus Rental Pune, 50 Seater Bus Hire Pune, 50 Seater Bus Booking Pune, 50 Seater AC Bus on Rent Pune, 50 Seater Luxury Bus Rental Pune, 50 Seater Bus for Outstation Pune, 50 Seater Bus for Wedding Pune, 50 Seater Bus for Corporate Events Pune, 50 Seater Bus for School Trips Pune, 50 Seater Bus for Group Travel Pune, 50 Seater Bus for Family Trip Pune, 50 Seater Bus for Family Tour Pune, 50 Seater Bus for Corporate Outing Pune, 50 Seater Bus for Wedding Guest Pune, 50 Seater Bus for School Tour Pune, 50 Seater Bus for College Trip Pune, 50 Seater Bus for Sightseeing Pune, 50 Seater Bus for Local Sightseeing Pune, 50 Seater Bus for Pune Darshan, 50 Seater Bus for Pilgrimage Pune, 50 Seater Bus for Temple Tour Pune, 50 Seater Bus for Tourist Group Pune, 50 Seater Bus for Group Tour Pune, 50 Seater Bus for Large Group Pune, 50 Seater Bus with Driver Pune, 50 Seater Private Bus Pune, 50 Seater AC Bus Rental Pune, 50 Seater AC Bus Hire Pune, 50 Seater AC Bus Booking Pune, 50 Seater Luxury Bus on Rent Pune, 50 Seater Luxury Bus Hire Pune, 50 Seater Luxury Bus Booking Pune, Premium 50 Seater Bus Pune, Affordable 50 Seater Bus Rental Pune, 50 Seater Bus Rental in Pune, 50 Seater Bus Hire in Pune, 50 Seater Bus Booking in Pune, 50 Seater Bus Outstation Rental Pune, 50 Seater Bus for Outstation Trip Pune, 50 Seater Bus One Way Pune, 50 Seater Bus Round Trip Pune, 50 Seater Bus Full Day Rental Pune, 50 Seater Bus Multi Day Rental Pune, 50 Seater Bus Weekend Rental Pune, 50 Seater Bus Tour Package Pune, 50 Seater Bus Sightseeing Package Pune, 50 Seater Bus Family Tour Package Pune, 50 Seater Bus Group Tour Package Pune, 50 Seater Bus Corporate Tour Pune, 50 Seater Bus Corporate Travel Pune, 50 Seater Bus Corporate Transportation Pune, 50 Seater Bus for Employee Transportation Pune, 50 Seater Bus for Office Trip Pune, 50 Seater Bus for Company Event Pune, 50 Seater Bus for Business Travel Pune, 50 Seater Bus for Conference Pune, 50 Seater Bus for Seminar Pune, 50 Seater Bus for Exhibition Pune, 50 Seater Bus for Training Program Pune, 50 Seater Bus for Industrial Visit Pune, 50 Seater Bus for Wedding Guest Transportation Pune, 50 Seater Bus for Marriage Pune, 50 Seater Bus for Reception Pune, 50 Seater Bus for Destination Wedding Pune, 50 Seater Bus for Event Transportation Pune, 50 Seater Bus for Airport Transfer Pune, 50 Seater Bus for Airport Pickup Pune, 50 Seater Bus for Airport Drop Pune, 50 Seater Bus for Pune Airport, 50 Seater Bus for Railway Station Transfer Pune, 50 Seater Bus for Pune Railway Station, 50 Seater Bus for Hotel Transfer Pune, 50 Seater Bus for Resort Transfer Pune, 50 Seater Bus for Guest Pickup Pune, 50 Seater Bus for Guest Drop Pune, 50 Seater Bus for School Picnic Pune, 50 Seater Bus for College Tour Pune, 50 Seater Bus for Student Group Pune, 50 Seater Bus for Religious Tour Pune, 50 Seater Bus for Maharashtra Tour Pune, 50 Seater Bus for Goa Trip Pune, 50 Seater Bus for Mumbai Trip Pune, 50 Seater Bus for Lonavala Trip Pune, 50 Seater Bus for Mahabaleshwar Trip Pune, 50 Seater Bus for Panchgani Trip Pune, 50 Seater Bus for Nashik Trip Pune, 50 Seater Bus for Shirdi Trip Pune, 50 Seater Bus for Kolhapur Trip Pune, 50 Seater Bus for Satara Trip Pune, 50 Seater Bus for Konkan Trip Pune, 50 Seater Bus for Alibaug Trip Pune, 50 Seater Bus for Matheran Trip Pune, 50 Seater Bus for Ratnagiri Trip Pune, 50 Seater Bus for Ganpatipule Trip Pune, 50 Seater Bus for Dapoli Trip Pune, 50 Seater Bus Rental Near Pune, 50 Seater Bus Hire Near Pune, 50 Seater Bus Booking Near Pune, 50 Seater Bus Rental Pimpri Chinchwad, 50 Seater Bus Hire Pimpri Chinchwad, 50 Seater Bus Rental Wakad, 50 Seater Bus Rental Hinjewadi, 50 Seater Bus Rental Kothrud, 50 Seater Bus Rental Baner, 50 Seater Bus Rental Aundh, 50 Seater Bus Rental Viman Nagar, 50 Seater Bus Rental Kharadi, 50 Seater Bus Rental Hadapsar, 50 Seater Bus Rental Kondhwa, 50 Seater Bus Rental Katraj, 50 Seater Bus Rental Shivajinagar, 50 Seater Bus Rental Swargate, 50 Seater Bus Rental Pimpri, 50 Seater Bus Rental Chinchwad, 50 Seater Bus Rental Talegaon, 50 Seater Bus Rental Moshi, 50 Seater Bus Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Fivezeroseatterbus ;